import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useAuth } from '../../contexts/AuthContext';
import MaintenancePage from '../../pages/common/MaintenancePage';

export default function MaintenanceGate({ children }) {
  const { effectiveRole, loading: authLoading } = useAuth();
  const [maintenance, setMaintenance] = useState(null); // null = snapshot not yet received
  const [message, setMessage]         = useState('');

  useEffect(() => {
    const ref = doc(db, 'settings', 'maintenance');
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          setMaintenance(snap.data().maintenanceMode === true);
          setMessage(snap.data().maintenanceMessage || '');
        } else {
          setMaintenance(false);
        }
      },
      (_err) => {
        // Fail open on Firestore error
        setMaintenance(false);
      }
    );
    return unsub;
  }, []);

  // Wait for both auth and snapshot to resolve
  if (authLoading || maintenance === null) return null;

  if (maintenance && effectiveRole !== 'admin') {
    return <MaintenancePage message={message} />;
  }

  return children;
}
